import React from 'react';

const ProgressTab = ({ plan }) => {
  // Use credit_profile as single source of truth
  const cp = plan.credit_profile || {};
  const currentScore = (cp.score && cp.score >= 300) ? cp.score
    : (plan.current_score && plan.current_score >= 300) ? plan.current_score
    : 620;
  const goalScore = cp.goal_score || plan.goal_score || 720;
  const scoreGain = goalScore - currentScore;
  const progressPercent = Math.min(100, Math.round(((currentScore - 300) / (goalScore - 300)) * 100));
  
  const scoreLabel = (s) => {
    if (!s || s < 300) return 'Fair';
    return s >= 800 ? 'Exceptional' : s >= 740 ? 'Very Good' : s >= 670 ? 'Good' : s >= 580 ? 'Fair' : 'Poor';
  };

  const projection = plan.projection || {};
  const scoreProjection = plan.score_projection || {};
  
  const getProjection = (days, projKey, spKey) => {
    if (projection[days]) return projection[days];
    if (projection[projKey]) return projection[projKey];
    const val = scoreProjection[spKey];
    if (val) {
      const strVal = String(val);
      // Filter out any invalid strings
      if (strVal && strVal !== '' && !['NaN', 'null', 'None', 'undefined'].includes(strVal)) {
        const num = parseInt(val);
        if (num >= 300 && num <= 850) return `Score: ${num}`;
      }
    }
    // Always calculate a reasonable projection
    const monthNum = spKey === 'after_month_1' ? 1 : spKey === 'after_month_2' ? 2 : 3;
    const est = Math.round(currentScore + (scoreGain * monthNum * 0.15));
    return `Est. Score: ${Math.min(est, goalScore)}`;
  };

  return (
    <div className="tab-content">
      <div className="tab-header">
        <h2 className="tab-title">Your Progress</h2>
      </div>

      <div className="score-card-large">
        <div className="score-comparison">
          <div className="score-box current">
            <div className="score-label">Current</div>
            <div className="score-value current-score" data-testid="current-score">
              {currentScore}
            </div>
            <div className="score-rating">{scoreLabel(currentScore)}</div>
          </div>

          <div className="score-arrow-container">
            <div className="score-arrow">&rarr;</div>
            <div className="score-gain">{`+${scoreGain} points`}</div>
          </div>

          <div className="score-box target">
            <div className="score-label">Goal</div>
            <div className="score-value target-score" data-testid="target-score">
              {goalScore}
            </div>
            <div className="score-rating">{scoreLabel(goalScore)}</div>
          </div>
        </div>

        <div className="progress-bar-container">
          <div className="progress-bar-large">
            <div className="progress-fill-large" style={{ width: `${progressPercent}%` }}></div>
          </div>
          <div className="progress-percentage">{progressPercent}% to goal</div>
        </div>
      </div>

      <div className="milestones-section">
        <h3 className="section-subtitle">Projected Milestones</h3>
        
        <div className="milestone-card">
          <div className="milestone-header">
            <span className="milestone-icon">&#x1F4C5;</span>
            <span className="milestone-title">30 Days</span>
          </div>
          <div className="milestone-value" data-testid="projection-30">
            {getProjection('30_days', 'days_30', 'after_month_1')}
          </div>
          <div className="milestone-description">
            Focus on high-utilization cards and autopay setup
          </div>
        </div>

        <div className="milestone-card">
          <div className="milestone-header">
            <span className="milestone-icon">&#x1F4C5;</span>
            <span className="milestone-title">60 Days</span>
          </div>
          <div className="milestone-value" data-testid="projection-60">
            {getProjection('60_days', 'days_60', 'after_month_2')}
          </div>
          <div className="milestone-description">
            Continue reducing utilization and maintain payment history
          </div>
        </div>

        <div className="milestone-card">
          <div className="milestone-header">
            <span className="milestone-icon">&#x1F3AF;</span>
            <span className="milestone-title">{plan.timeline_months || 6} Months</span>
          </div>
          <div className="milestone-value">
            Target: {goalScore}
          </div>
          <div className="milestone-description">
            Reach your goal score with consistent action
          </div>
        </div>
      </div>

      <div className="reminder-card">
        <div className="reminder-icon">&#x1F514;</div>
        <div className="reminder-content">
          <div className="reminder-title">Recheck in 30 Days</div>
          <div className="reminder-text">
            Pull your updated credit report to track progress and adjust your plan
          </div>
        </div>
        <button className="reminder-btn" data-testid="set-reminder-btn">
          Set Reminder
        </button>
      </div>
    </div>
  );
};

export default ProgressTab;
